import { StyledLegend } from '@/components/shared/GenericBarChart/style';
import { abyssColors } from '@/theme/colors';
import { titleCase } from '@/utils';
import { Box, Stack } from '@mui/material';

type LegendProps = {
  data: { [key: string]: string };
};

export const CustomLegend = ({ data }: LegendProps) => {
  return (
    <Stack direction="row" spacing={3.75} justifyContent="flex-start" ml={2}>
      {Object.entries(data).map(([label, color]) => (
        <Stack key={label} direction="row" alignItems="center">
          <StyledLegend bgcolor={color} />
          <Box style={{ fontSize: '1.2rem', fontWeight: 400, color: abyssColors.primary[400] }}>
            {titleCase(label)}
          </Box>
        </Stack>
      ))}
    </Stack>
  );
};
